import { Handle, Position } from '@xyflow/react'
import { selectedBorder } from '../selectedBorder.js'

/**
 * RuleTimeInStateNode — outputs the seconds since this transition's SOURCE
 * state was entered (RuleEvaluator `ruleTimeInState`). Wire it into a Compare
 * (e.g. `> 3`) to leave the state after a fixed time; drive the threshold from
 * a Random-set variable for a random hold. The clock starts when the state is
 * entered, so it includes the crossfade into it.
 *
 * data._debugValue — live seconds injected by TransitionRuleEditor while the
 * source state is the active one; null otherwise.
 */
export function RuleTimeInStateNode({ data, selected }) {
  const v = data._debugValue
  const live = typeof v === 'number'
  return (
    <div style={{
      background: '#1e1500',
      border: `2px solid ${selected ? selectedBorder('#c07820') : '#c07820'}`,
      borderRadius: 6,
      padding: '8px 12px',
      minWidth: 160,
      color: '#ddd',
      fontFamily: 'var(--m-font)',
      fontSize: 11,
    }}>
      <div style={{ color: '#e09030', fontWeight: 'bold', fontSize: 9, letterSpacing: 1, marginBottom: 6 }}>
        TIME IN STATE
      </div>
      <div style={{
        background: '#120e00', border: '1px solid #604010', borderRadius: 3,
        padding: '3px 8px', fontSize: 12, textAlign: 'center',
        color: live ? '#ffc040' : '#403820',
      }}>
        {live ? `${v.toFixed(2)}s` : '—'}
      </div>
      <div style={{ marginTop: 5, fontSize: 8, color: '#806040', letterSpacing: 0.5 }}>
        {live ? 'seconds since the state was entered' : 'state not active'}
      </div>
      <Handle type="source" position={Position.Right} id="out" style={{ background: '#c07820', width: 10, height: 10 }} />
    </div>
  )
}
